// extracted by mini-css-extract-plugin
export default {"titleRow":"b2994c8b","title":"c2bdd391","switchYear":"cc72f89f"};